module.exports = __webpack_public_path__ + "img/resp-explainer.048f1e14.svg";